// Parse work exceptions from environment variable
const WORK_EXCEPTIONS_LIST = process.env.NEXT_PUBLIC_WORK_EXCEPTIONS
  ? process.env.NEXT_PUBLIC_WORK_EXCEPTIONS.split(',').map((id) => parseInt(id.trim(), 10))
  : [];

// Check if given index is in work exceptions list
export const hasWorkException = (idx: number): boolean => WORK_EXCEPTIONS_LIST.includes(idx);
